export default "__VITE_ASSET__617b584f__"